import { PENGATURAN_SIMPANAN_SUKARELA } from "../../constants/admin/masterdata/constants";

const initialState = {
  data: {},
  loadingData: false,
  loadingUpdate: false,
  updateSuccess: false,
};

export const simpananSukarelaReducer = (state = initialState, action) => {
  switch (action.type) {
    case PENGATURAN_SIMPANAN_SUKARELA.LOADING_DATA_PENGATURAN_SUKARELA_SUCCESS:
      return { ...state, loadingData: action.load };

    case PENGATURAN_SIMPANAN_SUKARELA.GET_DATA_PENGATURAN_SUKARELA_SUCCESS:
      return {
        ...state,
        data: action.data ?? {},
      };

    case PENGATURAN_SIMPANAN_SUKARELA.LOADING_ACTION_PENGATURAN_SUKARELA:
      return { ...state, loadingUpdate: action.load };

    case PENGATURAN_SIMPANAN_SUKARELA.UPDATE_SUKARELA_SUCCESS:
      return { ...state, updateSuccess: true };

    case PENGATURAN_SIMPANAN_SUKARELA.UPDATE_SUKARELA_RESET:
      return { ...state, updateSuccess: false };

    default:
      return state;
  }
};
